"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosHttpClient = void 0;
const tslib_1 = require("tslib");
const httpClientInterface_1 = require("./httpClientInterface");
const axios_1 = tslib_1.__importDefault(require("axios"));
class AxiosHttpClient {
    constructor(baseUrl) {
        this.options = {
            baseURL: '',
            headers: {
                'content-type': 'application/json'
            }
        };
        this.options.baseURL = baseUrl;
    }
    get(url, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const request = Object.assign(Object.assign({}, options), this.options);
            return yield this.wrapRequest(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
                const response = yield axios_1.default.get(url, request);
                return response.data;
            }));
        });
    }
    post(url, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const request = Object.assign(Object.assign({}, options), this.options);
            return yield this.wrapRequest(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
                const response = yield axios_1.default.post(url, request);
                return response.data;
            }));
        });
    }
    put(url, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const request = Object.assign(Object.assign({}, options), this.options);
            return yield this.wrapRequest(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
                const response = yield axios_1.default.put(url, request);
                return response.data;
            }));
        });
    }
    wrapRequest(fn) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                return yield fn();
            }
            catch (error) {
                if (axios_1.default.isAxiosError(error)) {
                    throw new httpClientInterface_1.HttpError(error.message);
                }
                else {
                    throw error;
                }
            }
        });
    }
}
exports.AxiosHttpClient = AxiosHttpClient;
//# sourceMappingURL=axiosHttpClient.js.map